import { resolveStrapiMediaUrl } from '../../../core/utils/strapi-media.util';

export function adaptQuoteBlock(
  entry: Record<string, unknown>,
  baseUrl: string,
): Record<string, unknown> {
  const img = entry['imageSrc'] as Record<string, unknown> | null;
  return {
    quote: `\u201C${(entry['quote'] as string) ?? ''}\u201D`,
    name: (entry['name'] as string) ?? '',
    role: (entry['role'] as string) ?? '',
    company: (entry['company'] as string) ?? undefined,
    imageSrc: img ? resolveStrapiMediaUrl(baseUrl, (img['url'] as string) ?? null) ?? undefined : undefined,
    imageAlt: typeof img === 'object' && img ? (img['alternativeText'] as string) ?? undefined : undefined,
    imageWidth: img ? (img['width'] as number) ?? 0 : 0,
    imageHeight: img ? (img['height'] as number) ?? 0 : 0,
  };
}
